import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import { Link } from "react-router-dom";

function OpenHouse() {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          textAlign: "center",
          backgroundColor: "#f2f0e4",
          py: 8,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 4,
            fontStyle: "italic",
          }}
        >
          GET YOUR PLACE
        </Typography>

        <Typography
          variant="h3"
          component="h2"
          sx={{
            mb: 2,
            fontStyle: "italic",
          }}
        >
          open house
        </Typography>

        <Typography
          variant="h4"
          component="h3"
          sx={{
            mb: 3,
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          Friday, MAY 30th
        </Typography>

        <Typography
          variant="h6"
          component="p"
          sx={{
            mb: 6,
            fontStyle: "italic",
          }}
        >
          sign up available on site
        </Typography>
      </Box>
    </Container>
  );
}

export default OpenHouse;
